import { Box } from '@ltvco/refresh-lib/theme';
import { Routes, Route, Navigate } from 'react-router-dom';

import { ChatPage } from 'components/ChatBV/components';
import { ChatProvider } from 'components/ChatBV/context';
import { NotFound } from 'routes';

export const ChatBVContainer = () => {
  return (
    <Box sx={{ height: '100vh', width: '100%' }}>
      <ChatProvider>
        <Routes>
          <Route path="/" element={<Navigate to="/chatbv/chat" replace />} />
          <Route path="/chat/*" element={<ChatPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </ChatProvider>
    </Box>
  );
};
